import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  GetDesignations,
  CreateDesignation,
  UpdateDesignation,
  DeleteDesignation,
} from "../Api";
import { ServiceQueryOptions, unwrapApiResponse } from "./query_helpers";
import { LOOKUP_STALE_TIME } from "../Constant/AppConstants";

export const designationQueryKeys = {
  designations: () => ["designations"] as const,
};

export const invalidateDesignationQueries = (queryClient: any) => {
  queryClient.invalidateQueries({ queryKey: ["designations"] });
};

export const useDesignationsQuery = (options?: ServiceQueryOptions) => {
  return useQuery({
    staleTime: LOOKUP_STALE_TIME,
    ...options,
    queryKey: designationQueryKeys.designations(),
    queryFn: async () => unwrapApiResponse(await GetDesignations()),
  });
};

export const useActiveDesignationsQuery = (options?: ServiceQueryOptions) => {
  return useQuery({
    staleTime: LOOKUP_STALE_TIME,
    ...options,
    queryKey: designationQueryKeys.designations(),
    queryFn: async () => unwrapApiResponse(await GetDesignations()),
  });
};

export const useDesignationsRequest = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () =>
      queryClient.fetchQuery({
        staleTime: LOOKUP_STALE_TIME,
        queryKey: designationQueryKeys.designations(),
        queryFn: async () => unwrapApiResponse(await GetDesignations()),
      }),
  });
};

export const useCreateDesignationMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: Parameters<typeof CreateDesignation>[0]) =>
      CreateDesignation(payload),
    onSuccess: (res) => {
      if (res?.success) {
        invalidateDesignationQueries(queryClient);
      }
    },
  });
};

export const useUpdateDesignationMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: Parameters<typeof UpdateDesignation>[0]) =>
      UpdateDesignation(payload),
    onSuccess: (res) => {
      if (res?.success) {
        invalidateDesignationQueries(queryClient);
      }
    },
  });
};

export const useDeleteDesignationMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: Parameters<typeof DeleteDesignation>[0]) =>
      DeleteDesignation(payload),
    onSuccess: (res) => {
      if (res?.success) {
        invalidateDesignationQueries(queryClient);
      }
    },
  });
};
